export default __webpack_public_path__ + "static/media/hero.575152b4.png";